// @ts-strict-ignore
import {Camera, ConnectivityState} from "@models";
import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
} from "@angular/core";
import {EventEmitterService} from "@event-emitter";
import {
	SimCameraRequestQueueService,
	SimCameraService,
	SimConfigurationService,
	SimSystemExtendedService,
	SimUtilityService,
} from "@services";
import {VideoStatus} from "../../../../types/video-status";
import {Translations} from "@translations";

@Component({
	selector: "sim-mjpeg-image",
	templateUrl: "./mjpeg-image.component.html",
	styleUrls: ["./mjpeg-image.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class MjpegImageComponent implements OnInit, OnDestroy, OnChanges {
	T = Translations;
	SimUtilityService = SimUtilityService;
	VideoStatus = VideoStatus;
	ConnectivityState = ConnectivityState;
	settings = SimConfigurationService.settings;

	@ViewChild("mjpegImage", {static: false})
	public mjpegImage: ElementRef<HTMLImageElement> = null;

	@Input()
	public mjpegVideoOptions: {
		cameraId: string;
		ipAddress: string;
		url: string;
		anonymousAccessAllowed: boolean;
		status: ConnectivityState;
	} = null;

	public camera: Camera = null;

	private timeoutHandle = null;

	constructor(
		private _simSystemService: SimSystemExtendedService,
		private _eventEmitterService: EventEmitterService,
		private _simCameraService: SimCameraService,
	) {}

	public ngOnInit() {
		this._eventEmitterService.onCameraStateChanged.subscribe((args) => {
			if (this.camera && this.camera.id === args.cameraState.id) {
				this.camera.status = args.cameraState.status;
			}
		});
	}

	public ngOnDestroy(): void {
		if (this.mjpegImage) {
			// This clears the src faster
			this.mjpegImage.nativeElement.src = "";
			this.mjpegImage = null;
		}
	}

	public async ngOnChanges(changes: SimpleChanges) {
		if (changes["mjpegVideoOptions"] && this.mjpegVideoOptions) {
			this.camera = await this._simCameraService.getCameraById(this.mjpegVideoOptions.cameraId);
		}
	}
}
